import React from "react";
import TextArea from "../../../TextArea/TextArea";

const Comment = ({onChange, value, onClick, title, height = 100, noMargin, ...rest}) => {
  return (
    <TextArea
      label={title}
      value={value}
      onChange={onChange}
      wrap='hard'
      maxLength={1000}
      height={height}
      noMargin={noMargin}
      {...rest}
    />
  );
};

export default Comment;
